import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '..';

export const selectAllNotifications = (state: RootState) => state.notification;

export const allTemplatesSelector = createSelector(
  selectAllNotifications, (state) => state,
);
